import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { useI18n } from "../lib/i18n";
import { Shield, Zap, Users, Trophy } from "lucide-react";

export default function Landing() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-[#101114]">
      <Header />
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 opacity-20"
          style={{ backgroundImage: "url(https://images.unsplash.com/photo-1763198216883-7473e2c7eabb?crop=entropy&cs=srgb&fm=jpg&q=85)", backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="absolute inset-0 bg-gradient-to-r from-[#101114] via-[#101114]/90 to-transparent" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-36">
          <div className="max-w-2xl fade-in">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-[#F5F3ED] mb-6" style={{fontFamily:"'Playfair Display', serif"}}>
              {t("landing.hero.title")}
            </h1>
            <p className="text-base lg:text-lg text-[#A8A8AD] leading-relaxed mb-10 max-w-xl">
              {t("landing.hero.sub")}
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/marketplace" data-testid="hero-browse-btn" className="bg-[#D4AF37] text-[#101114] hover:bg-[#F2D98D] transition-colors font-bold rounded-sm px-8 py-3">
                {t("landing.cta.browse")}
              </Link>
              <Link to="/register" data-testid="hero-register-btn" className="border border-[#35353B] text-[#F5F3ED] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors rounded-sm px-8 py-3">
                {t("landing.cta.register")}
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { icon: Shield, title: t("landing.f1.title"), desc: t("landing.f1.desc") },
            { icon: Zap, title: t("landing.f2.title"), desc: t("landing.f2.desc") },
            { icon: Users, title: t("landing.f3.title"), desc: t("landing.f3.desc") },
            { icon: Trophy, title: t("landing.f4.title"), desc: t("landing.f4.desc") },
          ].map((f, i) => (
            <div key={i} data-testid={`feature-card-${i}`} className="bg-[#202127] border border-[#35353B] rounded-lg p-6 hover:-translate-y-1 hover:border-[#D4AF37] transition-all duration-300">
              <f.icon className="text-[#D4AF37] mb-4" size={28} />
              <h3 className="text-xl font-semibold text-[#F5F3ED] mb-2" style={{fontFamily:"'Playfair Display', serif"}}>{f.title}</h3>
              <p className="text-sm text-[#A8A8AD] leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
